import React, { useMemo } from "react";
import clsx from "clsx";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import * as Dati from "src/Dati";
import * as DatiFide from "src/DatiFide";
import { Trad } from "src/components/";
import { _StatusBar } from "../../components";
import { getTotalIndex, getFinancialSituation } from "./helpers";

const useStyles = makeStyles(({ palette }: Theme) => ({
    circle: {
        margin: "0 auto",
        width: "150px",
        height: "150px",
        borderRadius: "100px",
        textAlign: "center",
        backgroundColor: palette.warning.light,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    successResult: {
        backgroundColor: palette.success.light
    }
}));

interface IAnalysisChartsProps {
    Data: DatiFide.CDatiFideValutazione;
    EconomicData: Dati.CDatiEconomici;
}

export const _AnalysisCharts: React.FC<IAnalysisChartsProps> = ({ Data, EconomicData }) => {
    const classes = useStyles();

    const totalIndex = useMemo(() => getTotalIndex(Data, EconomicData), [Data, EconomicData]);
    const financialSituation = useMemo(() => getFinancialSituation(EconomicData), [EconomicData]);
    const equityDebt = (EconomicData.PassivoConsolidato + EconomicData.PassivoCorrente) / EconomicData.PatrimonioNetto;
    const successResult = financialSituation <= 5 && equityDebt <= 3 && EconomicData.Punteggio <= 5 && (totalIndex / 105) * 100 >= 50;

    return (
        <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={8} container spacing={4}>
                <Grid item xs={12}>
                    <_StatusBar Value={totalIndex} Label="IndiceAllRisks" Max={105} />
                </Grid>
                <Grid item xs={12}>
                    <_StatusBar Value={10 - (financialSituation <= 10 ? financialSituation : 10)} Label="IndiceSituazioneFinanziaria" Max={10} />
                </Grid>
                <Grid item xs={12}>
                    <_StatusBar Value={10 - (equityDebt <= 10 ? equityDebt : 10)} Label="IndiceIndebitamento" Max={10} />
                </Grid>
                <Grid item xs={12}>
                    <_StatusBar Value={8 - (EconomicData.Punteggio <= 8 ? EconomicData.Punteggio : 8)} Label="IndiceRatingEsterno" Max={8} />
                </Grid>
            </Grid>
            <Grid item xs={12} md={4}>
                <div
                    className={clsx(classes.circle, {
                        [classes.successResult]: successResult
                    })}
                >
                    <Typography variant="h5">{Trad.Trad(Trad.Trad(successResult ? "GO" : "REFERRAL"))}</Typography>
                </div>
            </Grid>
        </Grid>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/BondsAssessment/AnalysisCharts.tsx